import { api } from "@/lib/apiClient";

export const ASAP = "Dès que possible";

// Créneaux calculés côté serveur : préparation 30 min, intervalle 15 min, bornés aux horaires d'ouverture.
export async function fetchTimeslots() {
  try {
    const { data } = await api.get("/timeslots");
    return data; // { available, asap, options: string[], message }
  } catch {
    return { available: false, asap: false, options: [], message: "Créneaux indisponibles" };
  }
}
